import React, { useContext } from 'react';
import ModalTemplate from '../Modals/_ModalTemplate';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { GBENSContext } from '../GBENSContainer';

const ExtractedData = ({ file, data }) => {
  const { referenceData } = useContext(GBENSContext);

  const getPackageName = (id) => {
    const packageTypes = referenceData?.packageTypes;
    if (packageTypes.length > 0) {
      const packageType = packageTypes.find(({ key }) => key === id);
      return packageType?.value || null;
    }
    return null;
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <div style={{ width: '35%', maxHeight: '100%', overflowY: 'auto', paddingRight: 20 }}>
        <TableContainer component={Paper} sx={{ marginTop: 2, marginBottom: 4 }}>
          <Table size="small" className="export-document-table">
            <TableBody>
              <RenderTableHead>Consignment Details</RenderTableHead>
              <RenderTableRow title="Consignment Reference" value={data.consignmentReference} />

              <RenderTableHead>Consignor</RenderTableHead>
              <RenderTableRow title="Company Name" value={data.Consignor?.companyName} />
              <RenderTableRow title="EORI" value={data.Consignor?.EORI} />
              <RenderTableRow title="Street Number" value={data.Consignor?.streetNumber} />
              <RenderTableRow title="Street Address" value={data.Consignor?.streetAddress} />
              <RenderTableRow title="Town/City" value={data.Consignor?.townCity} />
              <RenderTableRow title="Postcode" value={data.Consignor?.postCode} />
              <RenderTableRow title="Country" value={data.Consignor?.Country} />

              <RenderTableHead>Consignee</RenderTableHead>
              <RenderTableRow title="Company Name" value={data.Consignee?.companyName} />
              <RenderTableRow title="EORI" value={data.Consignee?.EORI} />
              <RenderTableRow title="Street Number" value={data.Consignee?.streetNumber} />
              <RenderTableRow title="Street Address" value={data.Consignee?.streetAddress} />
              <RenderTableRow title="Town/City" value={data.Consignee?.townCity} />
              <RenderTableRow title="Postcode" value={data.Consignee?.postCode} />
              <RenderTableRow title="Country" value={data.Consignee?.Country} />

              {data.lines.map((line, index) => (
                <React.Fragment key={line.commcode}>
                  <RenderTableHead>Line {index + 1}</RenderTableHead>
                  <RenderTableRow title="Commodity Code" value={line.commcode} />
                  <RenderTableRow title="Goods Description" value={line.goodsDescription} />
                  <RenderTableRow title="Package Type" value={getPackageName(line.packageType)} />
                  <RenderTableRow title="Packaging Marks" value={line.packagingMarks} />
                  <RenderTableRow title="No. of Packages" value={line.numPackages} />
                  <RenderTableRow title="No. of Pieces" value={line.noOfPieces} />
                  <RenderTableRow title="Gross Weight (kg)" value={line.grossWeight} />
                  <RenderTableRow title="Dangerous Goods Code" value={line.unDangerousGoodsCode} />
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div style={{ width: '65%', maxHeight: '100%' }}>
        <embed src={file} type="application/pdf" width="100%" height="100%" title="Embedded PDF Viewer" />
      </div>
    </div>
  );
};

const RenderTableHead = ({ children }) => {
  return (
    <TableRow>
      <TableCell colSpan={2} className="table-header">
        {children}
      </TableCell>
    </TableRow>
  );
};

const RenderTableRow = ({ title, value }) => {
  return (
    <TableRow>
      <TableCell>{title}</TableCell>
      <TableCell>{value || <span className="not-found">Not found</span>}</TableCell>
    </TableRow>
  );
};

const PDFDataModal = ({ file, data, isOpen, setIsOpen }) => {
  return (
    <ModalTemplate
      title="Viewing Extracted Data"
      body={<ExtractedData file={file} data={data} />}
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      buttons={[]}
      fullScreen
    />
  );
};

export default PDFDataModal;
